export const toNumber = (value: string) => {
  return parseFloat(value.replaceAll(",", ""));
};

const dollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  // minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const toDollar = (amount: any = 0) => {
  return dollarFormatter.format(Number(amount));
};

// Apparently we don't need this
export const centsToDollar = (amount: number) => {
  return amount / 100;
}

// Not currently used. Was used as an onBlur effect to automatically add .00 if not present in input
export const addZeroCentsToInputIfMissing = (input: HTMLInputElement) => {
  let value = input.value;
  let match = /\.\d\d$/.test(value);
  if (!match) {
    if (/\./.test(value)) {
      input.value = value.replace(/\.\d*/, '.00');
    } else {
      input.value = value + '.00';
    }
  }
}

export const omitDollar = (value: string = "") => {
  if (!value) {
    return value;
  }
  return value.replaceAll("$", "").replaceAll(",", "");
};

export const toIntString = (value: string | number) => {
  if (!value) {
    return value;
  }
  if (typeof value === "number") {
    value = value.toString();
  }
  const om = omitDollar(value);
  if (om === '-') {
    return om;
  }
  const res = Number(om.replace(/\.\d+$/, "")).toString();
  if (res === 'NaN') {
    return '';
  }
  return res;
};

export const toFloatString = (value?: string | number | null) : string | null =>  {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === "number") {
    value = value.toString();
  }

  const om = omitDollar(value);
  const trailing = om.match(/\.0*$/)?.[0]?.substring(0, 3);
  let num = Number(om.replace(/[^\d.]/g, ""));
  if (num > 999999990) {
    num = 999999990;
  }
  return num.toString() +  (trailing ? trailing : '');
};

export const toFloatStringAllowingNegative = (value: string) => {
  if (!value) {
    return value;
  }
  const om = omitDollar(value);
  const trailing = om.match(/\.0*$/)?.[0]?.substring(0, 3);

  if (om.charAt(0) === '-') {
    // Ignore first character; replace all non-digits
    var num = Number(om.replace(/(?!^)(\D*)/g, ""));
  } else {
    // Replace all non-digits
    var num = Number(om.replace(/(\D*)/g, ""));
  }
  if (num > 999999990) {
    num = 999999990;
  }
  return num.toString() +  (trailing ? trailing : '');
};

/// nondestructive (preserve leading zeros)
export const toIntStringND = (value: string | number) => {
  if (!value) {
    return value;
  }
  if (typeof value === "number") {
    value = value.toString();
  }
  const om = omitDollar(value);
  if (om === '-') {
    return om;
  }
  return om.replaceAll(/\D/g, "").replace(/\.\d\d$/, "");
};

export const withTwoDecimalPlaces = (value: string | number) : string => {
  if (!value) {
    return "0.00";
  }
  if (typeof value === "number") {
    value = value.toString();
  }
  const om = omitDollar(value);
  if (om === '-') {
    return om;
  }
  const res = Number(om).toFixed(2);
  return res;
}

export const omitHyphen = (value: string | undefined = "") => {
  if (!value) {
    return value;
  }
  return value.toString().replaceAll("-", "");
};

/// Given "xxx-xxx-xxxx", return "xxxxxxxxxx"
export const extractSSN = (value: string = "") => {
  if (!value) {
    return value;
  }
  return value.toString().replaceAll("-", "").replaceAll(" ", "");
}

export const maybeCleanInt = (value: string = "") => {
  if (!value || value === "") {
    return null;
  }
  return value.replaceAll(/\D/g, "");
};

export const filterNulls = (obj: any) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
};

export const formatSSN = (value: string) => {
  if (!value) {
    return value;
  }
  if (value.length === 11) {
    return value;
  }
  value = value.toString().replace(/\D/g, "");
  value = value.replace(/^(\d{3})/, "$1-");
  value = value.replace(/-(\d{2})/, "-$1-");
  value = value.replace(/(\d)-(\d{4}).*/, "$1-$2");
  return value;
};

export const formatMaskedSSN = (value: string) => {
  /// transform "123-45-6789" to "XXX-XX-6789"
  value = formatSSN(value);
  value = 'XXX-XX-' + value.slice(-4);
  return value;
}

export const formatPhone = (value: string) => {
  if (!value) {
    return value;
  }
  value = value.replace(/\D/g, "");
  value = value.replace(/^(\d{3})/, "($1)-");
  value = value.replace(/-(\d{3})/, "-$1-");
  value = value.replace(/(\d)-(\d{4}).*/, "$1-$2");
  return value;
};

export const dataURLtoFile = (dataurl: string, filename: string) => {
  let byteString;
  if (dataurl.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataurl.split(",")[1]);
  else byteString = unescape(dataurl.split(",")[1]);

  // separate out the mime component
  const mimeString = dataurl.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new File([ia], filename, { type: mimeString });
};
